import { render, staticRenderFns } from "./Bashbet.vue?vue&type=template&id=3adf9d28&scoped=true&"
import script from "./Bashbet.vue?vue&type=script&lang=js&"
export * from "./Bashbet.vue?vue&type=script&lang=js&"
import style0 from "./Bashbet.vue?vue&type=style&index=0&id=3adf9d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf9d28",
  null
  
)

export default component.exports